import { render, staticRenderFns } from "./BoundaryMain.vue?vue&type=template&id=85a15000&scoped=true"
import script from "./BoundaryMain.vue?vue&type=script&lang=js"
export * from "./BoundaryMain.vue?vue&type=script&lang=js"
import style0 from "./BoundaryMain.vue?vue&type=style&index=0&id=85a15000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a15000",
  null
  
)

export default component.exports